<template>
  <div>
    <b-form-select v-model="selected" :options="options"></b-form-select>
  </div>
</template>

<script>

export default {
  name: "balancing-payment-status-select",
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: undefined
    },
  },
  data() {
    return {
      selected: this.value || null,
      options: [
        { value: null, text: this.placeholder ? this.placeholder : this.$t('Please select {something}', { something: this.$t('sale_notes.type') }) },
        { value: 'paid_off', text: 'Lunas' },
        { value: 'partially_paid_off', text: 'Kurang Bayar' },
        { value: 'overpaid', text: 'Lebih Bayar' },
      ]
    }
  },
  watch: {
    selected(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val);
      }
    },
    value(val){
      this.selected = val !== this.selected ? val ?? null : this.selected;
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
